import { trpc } from '@client/trpc/client';

export type TrpcUtils = ReturnType<typeof trpc.useUtils>;

export type TrpcClient = TrpcUtils['client'];

export function useTrpc() {
    const utils = trpc.useUtils();

    return {
        trpc,
        trpcUtils: utils,
        trpcClient: utils.client,
    };
}
